import { Injectable } from "@angular/core";
import { SchoolMetricCardConfig } from "../models/metric-cards/school-metric-card-config.model";
import { SchoolMetricCardInfo } from "../models/metric-cards/school-metric-card-info.model";
import { SchoolMetricCategory } from "../models/metric-cards/school-metric-category.enum";
import { SchoolStatEntity } from "../models/stat-entities/school-stat-entity.model";
import { DateTimeUtilService } from "../../shared/util/date-time-util.service";
import { DrillDownType } from "../models/ui-models/drill-down-details.model";

@Injectable({
    providedIn: 'root'
})
export class SchoolKeyMetricsUtilService {

    constructor(private dateTimeUtilService: DateTimeUtilService) {

    }

    private schoolMetricCardConfigs: SchoolMetricCardConfig[] = [
        {
            category: SchoolMetricCategory.enrolled,
            label: 'Enrolled Students',
            iconClass: 'fa fa-users',
            iconBoxClass: 'blue',
            drillDownType: DrillDownType.studentsEnrolled,
            valueFunction: (data: SchoolStatEntity) => {
                return data.ActiveStudents?.toString() || '0';
            },
        },
        {
            category: SchoolMetricCategory.avgCourseTime,
            label: 'Avg Course Time Per Student',
            iconClass: 'fa fa-check-circle',
            iconBoxClass: 'green',
            drillDownType: DrillDownType.none,
            valueFunction: (data: SchoolStatEntity) => {
                const averageTimeSeconds = data.AverageProgress || 0;

                if (averageTimeSeconds === 0) {
                    return 'N/A';
                }

                const durationText = this.dateTimeUtilService.formatDurationMinutesSeconds(averageTimeSeconds, { showSeconds : false, showText : true });
 
                if (!durationText) {
                    return 'N/A';
                }

                return durationText;
            }
        },
        {
            category: SchoolMetricCategory.assignmentsActive,
            label: 'Current Assignments',
            iconClass: 'fa fa-file-alt',
            iconBoxClass: 'orange',
            drillDownType: DrillDownType.assignmentsCurrent,
            valueFunction: (data: SchoolStatEntity) => {
                const count = (data.RoSchoolAssignmentStats?.ActiveAssignments || 0) - (data.RoSchoolAssignmentStats?.PastDueAssignments || 0);

                return count.toString();
            }
        },
        {
            category: SchoolMetricCategory.assignmentsPastDue,
            label: 'Assignments Past Due',
            iconClass: 'fa fa-exclamation-triangle',
            iconBoxClass: 'red',
            drillDownType: DrillDownType.assignmentsPastDue,
            valueFunction: (data: SchoolStatEntity) => {
                const count = data.RoSchoolAssignmentStats?.PastDueAssignments || 0;

                return count.toString();
            }
        },
      
          {
            category: SchoolMetricCategory.acsTestPassRate,
            label: 'ACS Test Average',
            iconClass: 'fa fa-award',
            iconBoxClass: 'purple',
            drillDownType: DrillDownType.acsTestTaken,
            valueFunction: (data: SchoolStatEntity) => {
                let passRate = data.ACSTestAverageScore;

                if (passRate == null) {
                    return 'None Taken';
                }

                const acsTestsTaken = data.ACSTestUploaded || 0;

                if (acsTestsTaken === 0) {
                    return 'None Taken';
                }

                return `${(passRate).toFixed(0)}% (${acsTestsTaken} Test${acsTestsTaken !== 1 ? 's' : ''})`;
            }
        },
        {
            category: SchoolMetricCategory.awaitingACSTestUpload,
            label: 'Awaiting ACS Test Upload',
            iconClass: 'fa fa-clock',
            iconBoxClass: 'blue-grey',
            attentionText : 'Needs Attention',
            drillDownType: DrillDownType.acsTestAwaitingUpload,
            valueFunction: (data: SchoolStatEntity, cardConfig?: Partial<SchoolMetricCardConfig>) => {

                const awaitingUpload = data.ACSAwaitingUpload || 0;

                if (awaitingUpload === 0) {
                    cardConfig.attentionText = '';

                    return '0 Students';
                }

                return `${awaitingUpload} Student${awaitingUpload > 1 ? 's' : ''}`;
            }
        },

    ];

    getSchoolMetricCardConfigs(): SchoolMetricCardConfig[] {
        return this.schoolMetricCardConfigs;
    }

    buildSchoolMetricCardInfos(schoolStats: SchoolStatEntity): SchoolMetricCardInfo[] {
        const cardInfos: SchoolMetricCardInfo[] = [];

        if (!schoolStats) {
            schoolStats = {
                ActiveStudents: 0,
                AverageCompletionTime: 0,
                AverageProgress: 0,
                CompletedStudents: 0,
                ACSAverageFirstTimePassRate: 0,
                ACSAwaitingUpload: 0,
                ACSTestUploaded: 0
            } as SchoolStatEntity;
        }

        for (const cardConfig of this.schoolMetricCardConfigs) {
            const cardInfo: SchoolMetricCardInfo = {
                ...cardConfig,
                value: null
            };

            cardInfo.value = cardConfig.valueFunction(schoolStats, cardInfo)

            cardInfos.push(cardInfo);
        }

        return cardInfos;
    }







}